import { ApiType } from "@gymflow/common";
import { PromotionPostDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { promotionQueryKeys } from "./promotionQueryKeys";

export function usePromotionEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      promotionId,
      patchedFields,
    }: {
      promotionId: number;
      patchedFields: Partial<PromotionPostDTO>;
    }) => {
      await api.promotionApi.update(promotionId, patchedFields);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: promotionQueryKeys.all() });
    },
  });
}
